module.exports = __webpack_public_path__ + "img/mobileintegrated4.2dabd88e.png";